import rmskincareAPI from '../utils/rmskincareAPI'

const roomApi = {
  getAllRoom: async () => {
    const result = await rmskincareAPI.get(
      `/room/list?status=1`
    )
    return result.data.data
  },

  addOrEditRoom:async(requestBody)=>{
    const result =await rmskincareAPI.post(
      `/room/save`,requestBody
    )
    return result.data.data
  },


}

export default roomApi
